import { AutoComplete, Input, Tooltip, Breadcrumb } from "antd";
import { t } from "i18next";
import { AscRed, DeleteIcon, DescGrey, DetailIcon, EditIcon, PlusIcon, SearchIcon } from "../../../../asset";
import style from './palletPage.module.css'
import CustomTable from "../../../../component/table/CustomTable";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useState } from "react";
import SelectSearch from "../../../../component/input/SelectSearch";
import { usePallet } from "./PalletPage.hooks";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';


export default function PalletList() {

    const {
        list,
        deleteConfirmationModalOpen,
        setDeleteConfirmationModalOpen,
        successModalOpen,
        setSuccessModalOpen,
        toAddPallet,
        toDetailPallet,
        toEditPallet,
        deleteData,
        deleteConfirmation,
        doDeletePallet,
        selectedId,
        selectedPalletName,
        options,
        onSearch,
        doGetPalletList,
        onSelect,
        searchKeyword,
        handlePagination,
        totalData,
        selectedDepotId,
        listDropdown,
        selectDepotId,
        statePageSize,
        setStatePageSize,
        handleChangeLimit,
        doClear,
        currentPage,
        onScroll,
        onSearchDDS,
        dropdownListLoading,
        depotKeyword
    } = usePallet()


    const DeliveryTypeListColumn = [
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("PALLET_LIST:PALLET_ID_FIELD")}
                </span>
            ),
            dataIndex: 'palletId',
            key: 'palletId',
            render: (palletId) => <span>{palletId}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("PALLET_LIST:PALLET_NAME_FIELD")}
                </span>
            ),
            dataIndex: 'palletName',
            key: 'palletName',

            render: (palletName) => <span>{palletName}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("PALLET_LIST:DESCRIPTION_PALLET_FIELD")}
                </span>
            ),
            dataIndex: 'description',
            key: 'description',
            render: (description) => <span>{description}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("PALLET_LIST:WEIGHT_FIELD")}
                </span>
            ),
            dataIndex: 'weigth',
            key: 'weigth',
            render: (weigth) => <span>{weigth}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("PALLET_LIST:LENGHT_FIELD")}
                </span>
            ),
            dataIndex: 'lenght',
            key: 'lenght',
            render: (lenght) => <span>{lenght}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("PALLET_LIST:HEIGHT_FIELD")}
                </span>
            ),
            dataIndex: 'height',
            key: 'height',
            render: (height) => <span>{height}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("PALLET_LIST:WIDTH_FIELD")}
                </span>
            ),
            dataIndex: 'width',
            key: 'width',
            render: (width) => <span>{width}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("PALLET_LIST:ACTION_FIELD")}
                </span>
            ),
            dataIndex: 'action',
            key: 'action',
            render: (action) => <span>{action}</span>,
        },
    ]

    const dataSource = list?.map((item) => (
        {
            palletId: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.pallet_id}
                </span>
            ),
            palletName: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.pallet_name}
                </span>
            ),
            description: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.description}
                </span>
            ),
            weigth: (
                <span className="font-roboto text-lg text-[#222222]">
                    {`${item.weight}`}
                </span>
            ),
            lenght: (
                <span className="font-roboto text-lg text-[#222222]">
                    {`${item.length}`}
                </span>
            ),
            height: (
                <span className="font-roboto text-lg text-[#222222]">
                    {`${item.height}`}
                </span>
            ),
            width: (
                <span className="font-roboto text-lg text-[#222222]">
                    {`${item.width}`}
                </span>
            ),
            action: (
                <div className="flex gap-[26px]">
                    <Tooltip title={t("PALLET_LIST:EDIT_TOOLTIP")} color="#CF0000">
                        <button>
                            <img src={EditIcon} onClick={() => toEditPallet(item)} />
                        </button>
                    </Tooltip>
                    <Tooltip title={t("PALLET_LIST:DELETE_TOOLTIP")} color="#CF0000">
                        <button>
                            <img src={DeleteIcon} onClick={() => deleteConfirmation(item.pallet_id, item.updated_at, item.pallet_name)} />
                        </button>
                    </Tooltip>
                    <Tooltip title={t("PALLET_LIST:DETAIL_TOOLTIP")} color="#CF0000">
                        <button >
                            <img src={DetailIcon} onClick={() => toDetailPallet(item.pallet_id)} />
                        </button>
                    </Tooltip>
                </div>
            )
        }
    ))

    const selectSearchData = listDropdown?.map((item) => ({
        value: item.depot_id,
        label: item.depot_name
    }))

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <DeleteConfirmationModal
                isOpen={deleteConfirmationModalOpen}
                onOk={() => setDeleteConfirmationModalOpen(false)}
                onCancel={() => doDeletePallet()}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Cancel"
                cancelText="Yes, Delete"
                title="Delete Data?"
                description={<p>Are you Sure want to delete <strong>{selectedId} - {selectedPalletName}</strong></p>}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => setSuccessModalOpen(false)}
                closable={false}
                width={280}
                className={style.deleteModal}
                okText="Ok"
                title="Success"
                description="Your data has been deleted"
            />

            <Breadcumbs
                jmlLevel={3}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Pallet`}
            />

            <h1 className='font-sans-bold text-2xl' id='title'>{t("PALLET_LIST:TITLE")}</h1>

            <div className={style.headerContainer + ' flex justify-between items-center'}>
                <div className="flex gap-[16px]">
                    <AutoComplete
                        options={options}
                        onSelect={onSelect}
                        allowClear={true}
                        onClear={() => doClear(selectedDepotId)}
                    // suffix={<img src={SearchIcon} />}
                    >
                        <Input
                            placeholder={"Search Name"}
                            height={47}
                            onChange={(event) => onSearch(event)}
                            suffix={<img src={!searchKeyword ? SearchIcon : null} />}
                            style={{ fontSize: "20px" }}
                        />
                    </AutoComplete>

                    {/* <SelectSearch style={style} onSelect={(value) => selectDepotId(value, 1, 10)} data={selectSearchData} defaultValue={selectSearchData ? selectSearchData[0] : ''} /> */}
                    {
                        listDropdown?.length !== 0 ?

                            <SelectSearch onScroll={(event) => onScroll(event, 'depotList')} keyword={depotKeyword} onChange={(value) => onSearchDDS(value, 'depotList')} onSelect={(value) => selectDepotId(value, 1, 10)} width={292} options={listDropdown} loading={dropdownListLoading} defaultValue={listDropdown[0].value} />

                            :

                            null
                    }
                </div>

                <PrimaryButton text={t("PALLET_LIST:ADD_PALLET_BUTTON")} prefixIcon={<img src={PlusIcon} />} action={() => toAddPallet()} />

            </div>

            <div className={style.tableContainer}>

                <CustomTable currentPage={currentPage} columns={DeliveryTypeListColumn} data={dataSource} pageLimit={statePageSize} onChange={(page, pageSize) => handleChangeLimit(page, pageSize, selectedDepotId)} total={totalData} showPagination />

            </div>
        </div>
    );
}